<template>
    <div>
        <div v-if="rowData.record_file.length > 0">
            <div v-for="(record, ind) in rowData.record_file" :key="ind"
                class="text-primary text-md font-semibold cursor-pointer flex items-center"
                @click.stop="startRecordCell(record)">
                <span>{{ 'Tệp ghi âm ' + (ind + 1) }}</span>
                <feather-icon icon="PlayCircleIcon" class="action-success icon-btn" svgClasses="h-5 w-5" />
            </div>
        </div>
        <!-- <vs-popup class="holamundo" id="popup-history-call-record-cell" :active.sync="showAudioRecordCell"
                  v-if="showAudioRecordCell"> -->
        <div class="vx-row" v-if="showAudioRecordCell" id="popup-history-call-record-cell">
            <div class="vx-col w-full flex justify-between">
                <!-- <h4>Ghi âm</h4>  -->
                <div></div>
                <feather-icon icon="XIcon" class="hover:text-danger" svgClasses="h-5 w-5"
                    @click="closeAudioRecordCell" />
            </div>
        </div>
        <vs-divider />
        <div class="vx-row" v-if="showAudioRecordCell">
            <div class="vx-col w-full">
                <audio autoplay name="media" controls :src="dataRecordCell" type="audio/wav" class="w-full">
                </audio>
            </div>
        </div>
        <!-- </vs-popup> -->
    </div>
</template>

<script>
import authConfig from "../../../../../../../../auth_config.json"

export default {
    name: "CellRendererRecord2",
    props: {
        rowData: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            showAudioRecordCell: false,
            dataRecordCell: null,
        }
    },
    watch: {
        showAudioRecordCell() {
            if (this.dataRecordCell && !this.showAudioRecordCell) this.deleteRecordFileCell()
        }
    },

    methods: {
        startRecordCell(e) {
            let payload = {
                recordFileUrl: e
            }
            this.$vs.loading();
            this.$crm.post('/ott/vbot/get-record-file', payload).then(res => {
                this.$vs.loading.close();
                if (res) {
                    this.dataRecordCell = authConfig.audioDomain + res.data;
                    this.showAudioRecordCell = true;
                    // let recordPopup = document.getElementById('popup-history-call-record-cell');
                    this.$nextTick(() => {
                        let recordPopup = document.getElementById('popup-history-call-record-cell');
                        if (recordPopup) {
                        let backgroundCall = recordPopup.querySelector('.vs-popup--background');
                        if (backgroundCall) recordPopup.removeChild(backgroundCall);
                    }
                    });
                  
                } else {
                    return this.$vs.notify({
                        text: 'Không tồn tại file ghi âm!',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                }
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Error',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        async closeAudioRecordCell() {
            await this.deleteRecordFileCell();
            this.dataRecordCell = null;
            this.showAudioRecordCell = false;
        },

        deleteRecordFileCell() {
            return new Promise((resolve, reject) => {
                let payload = {
                    recordFileUrl: this.dataRecordCell,
                }

                this.$vs.loading();
                this.$crm.post('/ott/vbot/delete-record-file', payload).then(() => {
                    resolve();
                    this.$vs.loading.close()
                }).catch((err) => {
                    reject(err);
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },
    }
}
</script>

<style lang="scss">
#popup-history-call-record-cell {
    .vs-popup--header {
        display: none;
    }
}
</style>
